/**
 * author: Soumya Shreyas
 */
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import {
  Form,
  OverlayTrigger,
  Table
} from "react-bootstrap";
import { withTranslation } from "react-i18next";
import {
  BiSearch,
  BiSort
} from "react-icons/bi";
import { CgSortAz } from "react-icons/cg";
import { FcFinePrint } from "react-icons/fc";
import { Link, useNavigate } from "react-router-dom";

import { CompanyContext, RegulationContext } from "../../../../App";
import Pagination from "../../../../components/Pagination/Pagination";
import {
  DEFAULT_ITEMS_PER_PAGE,
  FORM_BUILDER_LISTING_URL,
  FORM_BUILDER_OPEN_SUBMIT_URL,
  LS_ACCESS_TOKEN_KEY,
  SORT_ORDER_DESC,
} from "../../../../core/constants/common";
import FormService from "../../../../core/service/FormService";
import Utils from "../../../../core/utilities/Utils";
import "../Forms.scss";

function FormSubmission({ t }) {
  const authToken = localStorage.getItem(LS_ACCESS_TOKEN_KEY);

  const [itemsTotalCount, setItemTotalCount] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(DEFAULT_ITEMS_PER_PAGE);
  const [currentPage, setCurrentPage] = useState(1);
  const [order, setOrder] = useState(SORT_ORDER_DESC);
  const [sortField, setSortField] = useState('');
  const [searchKey, setSearchKey] = useState("");
  const [forms, setForms] = useState([]);
  const { glbRegulation, setGlbRegulation } = useContext(RegulationContext);
  const { glbCompany, setGlbCompany } = useContext(CompanyContext);
  const glbRegulationId = glbRegulation?.id ? glbRegulation.id : "";
  const glbCompanyId = glbCompany?.companyId ? glbCompany.companyId : "";
  const currentRoute = window.location.pathname;

  const navigate = useNavigate();
  useEffect(() => {
    if (glbCompany && glbRegulation) {
      setSortField('sharedOn');
      getForms(0, itemsPerPage, searchKey, 'sharedOn', order);
    }

  }, [glbRegulationId, glbCompanyId]);

  const getForms = (pageNumber, itemsPerPageVal, searchVal = "", sortField, orderVal) => {
    var perPage = '';
    if (pageNumber > 0) {
      pageNumber = pageNumber - 1;
    } else {
      setCurrentPage(1);
    }
    if (itemsPerPageVal > 0) {
      perPage = itemsPerPageVal;
    } else {
      perPage = itemsPerPage;
    }
    var sort = sortField + "," + orderVal;
    var data = JSON.parse(localStorage.getItem("authority"));
    const supplierId = data.profile.company.id;
    FormService.getSupplierSubmissions(
      pageNumber,
      perPage,
      sort
    ).then((response) => {
      var totalPages = parseFloat(response.headers["x-total-count"]);
      setItemTotalCount(totalPages);
      setForms([...response.data]);
    })
    .catch((error) => {
    });
  };
  const handleSort = (val) => {
    let orderval = null;
    if (sortField === val && order === "asc") {
      orderval = 'desc';
    } else {
      orderval = 'asc';
    }
    setOrder(orderval);
    setSortField(val);
    getForms(0, itemsPerPage, searchKey, val, orderval);
  };
  const handleSearch = (key) => {
    setSearchKey(key);
    getForms(0, itemsPerPage, key, sortField, order);
  };
  const handleForm = (action, id, externalId, sId) => {
    const formType = "ASSESSMENT";
    var tokenKey = "";
    FormService.getSubmissionToken(id)
      .then((response) => {
        tokenKey = response.data;
        var string = Utils.generateUrlParamFormCreate(
          action,
          authToken,
          formType,
          glbRegulationId,
          externalId,
          tokenKey,
          sId,
          { route: currentRoute }
        );
        var encodedDat = Utils.encodeBase64(string);
        window.location.href = FORM_BUILDER_LISTING_URL + `/?q=${encodedDat}`;
      })
      .catch((error) => {
      });
  };
  
  const handleSubmittedForm = (form) => {
    window.location.href = FORM_BUILDER_OPEN_SUBMIT_URL + `/${form.token}`;
  };

  return (
    <>
      <div className="FormsList">
        <div className="List_header">
          <h5 className="MH">{t("Assessments.label")}</h5>
          <div className="List_sorts_menu">
            <ul>
            </ul>
          </div>
        </div>

        <div className="List_Table_01">
          <div className="List_table-card01_head">
            <div className="List_table-card_Search_01">
              <div className="List_table-card_Search_Box">
                <Form>
                  <input
                    type="text"
                    className="form-control"
                    value={searchKey}
                    onChange={(e) => handleSearch(e.target.value)}
                    placeholder="Search by Name"

                  />
                  <a className="Search_iocnBox cursor" onClick={() => handleSearch(searchKey)}>
                    <BiSearch />
                  </a>
                </Form>
              </div>
            </div>
            <div className="List_table-card01_sort">
              <ul>
                <li className="filter">
                  <Link to="#">
                    <button className="btn btn-secondary"><CgSortAz /> {t("Filter.label")}</button>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="card List_table-card01">
            <Table responsive="sm">
              <thead>
                <tr>
                  <th className="th_check">
                    <Form.Check
                      inline
                      name="group1"
                      type="checkbox"
                      id="inline-checkbox-1"
                    />
                  </th>
                  <th>
                    <Link to="#" onClick={() => handleSort("name")}>
                      {t("FormTitle.label")}
                      <BiSort />
                    </Link>
                  </th>
                  <th>
                    <Link to="#" onClick={() => handleSort("sharedOn")}>
                      {t("SharedOn.label")}
                      <BiSort />
                    </Link>
                  </th>
                  <th>{t("ReportingPeriod.label")}</th>
                  <th>{t("LastSubmissionDate.label")}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {forms?.length > 0 ? (
                  forms?.map((item) => (
                    <tr key={item.id}>
                      <td className="checkbox">
                        {" "}
                        <Form.Check
                          inline
                          name="group1"
                          type="checkbox"
                          id="inline-checkbox-1"
                        />
                      </td>
                      <td>
                        <OverlayTrigger
                          placement="top"
                          overlay={Utils.renderTooltip(
                            t("Clicktoviewsubmissions.label")
                          )}
                        >
                          <button
                            className="buttonLink"
                            onClick={() => handleSubmittedForm(item)}>
                            {item.formName}
                          </button>
                        </OverlayTrigger>

                        <p className="m-0">{item.regulationName}</p>
                        {!glbRegulationId && (
                          <p className="m-0">
                            {item.regulation && item.regulation.name}
                          </p>
                        )}
                      </td>
                      <td>{moment(item.sharedOn).format("MMM DD, YYYY")}</td>
                      <td>{item.reportingPeriod ? moment(item.reportingPeriod).format("MMM DD, YYYY") : "-"}</td>
                      <td>{item.lastSubmissionDate ? moment(item.lastSubmissionDate).format("MMM DD, YYYY") : "-"}</td>

                      <td>                        
                        {/* <Dropdown>
                          <Dropdown.Toggle
                            variant="blank_outline"
                            id="dropdown-basic"
                          >
                            <BiDotsHorizontalRounded />
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <Dropdown.Item
                              onClick={() =>
                                handleForm("SUBMIT", item.id, item.externalId, item.submissionId)
                              }
                            >
                              {t("Submit.label")}
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown> */}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center">
                      <div className="Nodatafound_box">
                        <h6><FcFinePrint className="me-2" /> {t("Nodatafound.label")}</h6>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
            <div className="p-2 List_footer_count">
              <Pagination
                itemsTotalCount={itemsTotalCount}
                itemsPerPage={itemsPerPage}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                alwaysShown={true}
                setItemsPerPage={setItemsPerPage}
                pageClicked={(pageNum, perPage) => {
                  getForms(pageNum, perPage, searchKey, sortField, order);
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
FormSubmission.propTypes = {};

export default withTranslation()(FormSubmission);
